export type ViewCursor = "pan" | "rotate" | null;

/**
 * Desktop cursor for the map canvas.
 *
 * Pan waits on an open hand and closes it while the map is actually panning.
 * Rotate keeps the map's own cursor (an empty value, so the canvas does not
 * cover it) and never switches to the pointing hand. A Point or Line under
 * the cursor is a pointing hand only when no view chord is held. Dragging a
 * lasso stays on the arrow, including while it crosses a Point or Line.
 * A Grab move uses the move cursor until it is confirmed or cancelled.
 * Every other spot is the arrow.
 */
export function canvasCursor(state: {
  view: ViewCursor;
  panning: boolean;
  overFeature: boolean;
  lasso: boolean;
  moving?: boolean;
}): string {
  if (state.moving) return "move";
  if (state.panning) return "grabbing";
  if (state.view === "pan") return "grab";
  if (state.view === "rotate") return "";
  if (state.lasso) return "default";
  if (state.overFeature) return "pointer";
  return "default";
}
